import axiosInstance from '../api.service.js';
import constants from '../../constants/constants';

const ENDPOINTORIGIN = "LogEvent/";

const getAllLogEvents = async () => await axiosInstance.get(ENDPOINTORIGIN + 'GetAllLogEvents', constants.REQUIRE_INTERCEPTORS);

export {
    getAllLogEvents
}